import * as React from 'react';

import SummaryTodoForm from './SummaryTodoForm';
import {ErrorResponse, SaveTodoRequest, Todo} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {message} from 'antd';
import locales from '../locales';
import {ClientRentalSummary} from "../api/dtos/summaries";

interface Props {
  summary: ClientRentalSummary;
  selectedYear: number;
  selectedMonth: number;
  onCancel: () => void;
  onSubmit: () => void;
}

interface State {
  error?: ErrorResponse;
}

class SummaryTodoEditor extends React.Component<Props, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;
  public state: State = {};

  public render(): React.ReactNode {
    const {summary, summary: {todo}, onCancel} = this.props;
    const editable = !summary.finalized;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <SummaryTodoForm
          todo={todo}
          editable={editable}
          onFormCancel={onCancel}
          onFormSubmit={this.onFormSubmit}
        >
          {this.state.error && <ErrorAlert style={{margin: '16px 0'}} error={this.state.error}/>}
        </SummaryTodoForm>
      </>
    );
  }

  private onFormSubmit = (todo: Todo) => {
    const {selectedYear, selectedMonth, summary: {rentalItem}} = this.props;

    // Filter empty rows
    todo.entries = todo.entries.filter(ent => ent.text.trim().length > 0);

    const request: SaveTodoRequest = {
      rentalItemId: rentalItem.id!,
      year: selectedYear,
      month: selectedMonth,
      todo,
    };

    const promise = furoApi.summaries.saveTodo(request)
      .then(this.onSaveSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onSaveSuccess = () => {
    this.setState({error: undefined,});

    message.success(locales.save_success);
    this.props.onSubmit();
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error})
  };

}

export default SummaryTodoEditor;


// WEBPACK FOOTER //
// ./src/summary/SummaryTodoEditor.tsx